module.exports = __webpack_public_path__ + "img/banner-hen.ecbebee0.png";